/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-undef */
/* eslint-disable object-shorthand */

import DOMPurify from 'dompurify';

export const PAGE_DIMENSIONS = {
  portrait: {
    letter: '8.5in 11in',
    long: '8.5in 13.8in',
    legal: '8.5in 14.8in',
    tabloid: 'XXXX 17in',
    executive: '7.25in 10.5in',
    a3: '297mm 420mm',
    a4: '210mm 297mm',
    a5: '148mm 210mm',
    a6: '105mm 148mm',
    a7: '74mm 105mm',
    a8: '52mm 74mm',
    a9: '37mm 52mm',
    a10: '26mm 37mm',
  },
  landscape: {
    letter: '11in 8.5in',
    long: '13.8in 8.5in',
    legal: '14.8in 8.5in',
    tabloid: 'XXXX 11in',
    executive: '10.5in 7.25in',
    a3: '420mm 297mm',
    a4: '297mm 210mm',
    a5: '210mm 148mm',
    a6: '148mm 105mm',
    a7: '105mm 74mm',
    a8: '74mm 52mm',
    a9: '52mm 37mm',
    a10: '37mm 26mm',
  },
};

export function getInitConfig(settings) {
  const {
    bottom = '0',
    left = '0',
    paper_margin = '0',
    paper_orientation = 'portrait',
    paper_size = 'letter',
    right = '0',
    top = '0',
  } = settings || {};
  const pageDimensions =
    PAGE_DIMENSIONS[paper_orientation][paper_size.toLowerCase()];
  const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');

  const config = {
    plugins: 'link image table lists advlist code',
    toolbar:
      'undo redo | bold italic underline strikethrough | image media table mergetags | image | align | numlist bullist lower-roman | removeformat | customLink | fileLink | idTag | superscript subscript | code | uploadbackground | uploadplaceholder',
    extended_valid_elements: 'style[type|src]',
    valid_children: '+body[style]', // Allow <style> as a child of <body>
    content_css: './custom-editor-style.css',
    content_style: `
      @page {
        size: ${pageDimensions}; 
        margin: ${top}${paper_margin} ${right}${paper_margin} ${bottom}${paper_margin} ${left}${paper_margin}; 
      }
      @media print { body { margin: 0; } }
      body, p { margin: 0; padding: 0; }
      .mce-content-body {
        margin: 0;
        padding: 0;
        height: 100%;
        box-sizing: border-box;
      }
      html, body {
        height: 100%;
      }
    `,
    height: 1000,
    image_title: true,
    image_caption: true,
    automatic_uploads: true,
    contextmenu_never_use_native: true,
    file_picker_types: 'image',
    file_picker_callback: (cb, value, meta) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.addEventListener('change', (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.addEventListener('load', () => {
          const id = 'blobid' + new Date().getTime();
          const blobCache = tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        });
        reader.readAsDataURL(file);
      });
      input.click();
    },
    setup: function (editor) {
      editor.ui.registry.addButton('uploadbackground', {
        text: 'Upload Background',
        onAction: function () {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.onchange = async function (e) {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('file', file);

            // Replace this URL with your actual upload endpoint
            try {
              const response = await fetch(process.env.REACT_APP_EGOV_UPLOAD_URL, {
                method: 'POST',
                headers: {
                  'X-Api-Key': process.env.REACT_APP_EGOV_UPLOAD_KEY,
                },
                body: formData,
              });

              if (response.ok) {
                const result = await response.json();
                const imageUrl = result.data.url; // Assuming the response contains the URL of the uploaded image
                const content = editor.getContent();
                const updatedContent = `
                <style>
                .bg {
                  margin: 0;
                  width: 100%;
                  z-index: -1;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              </style>
              <img src='${imageUrl}' class='bg'></img>
              ${content}`;
                editor.setContent(sanitizeHtml(updatedContent));
              } else {
                console.error('Upload failed:', response.statusText);
              }
            } catch (error) {
              console.error('Upload error:', error);
            }
          };
          input.click();
        },
      });
      editor.ui.registry.addButton('uploadplaceholder', {
        text: 'Upload Placeholder',
        onAction: function () {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.onchange = async function (e) {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('file', file);

            // Replace this URL with your actual upload endpoint
            try {
              const response = await fetch(process.env.REACT_APP_EGOV_UPLOAD_URL, {
                method: 'POST',
                headers: {
                  'X-Api-Key': process.env.REACT_APP_EGOV_UPLOAD_KEY,
                },
                body: formData,
              });

              if (response.ok) {
                const result = await response.json();
                const imageUrl = result.data.url; // Assuming the response contains the URL of the uploaded image

                // editor.dom.setStyles(editor.getBody(), {
                //   'background-image': `url('${imageUrl}')`,
                //   'background-size': 'cover'
                // });
                const content = editor.getContent();
                const updatedContent = `<style>.placeImage { background-image: url('${imageUrl}'); background-size: cover; }</style>${content}`;
                editor.setContent(sanitizeHtml(updatedContent));
              } else {
                console.error('Upload failed:', response.statusText);
              }
            } catch (error) {
              console.error('Upload error:', error);
            }
          };
          input.click();
        },
      });
      editor.ui.registry.addMenuItem('print', {
        text: 'Print',
        icon: 'print',
        onAction: function () {
          const content = editor.getContent();
          const safeContent = sanitizeHtml(content);
          const printWindow = window.open();
          printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <style>
                @page {
                  size: ${pageDimensions}; 
                  margin: ${top}${paper_margin} ${right}${paper_margin} ${bottom}${paper_margin} ${left}${paper_margin}; 
                }
                @media print { body { margin: 0; } }
                body, p { margin: 0; padding: 0; }
                .mce-content-body {
                  margin: 0;
                  padding: 0;
                  height: 100%;
                  box-sizing: border-box;
                }
                html, body {
                  height: 100%;
                }
              </style>
            </head>
            <body>${safeContent}</body>
          </html>
        `);
          printWindow.document.close();
          setTimeout(() => {
            printWindow.print();
          }, 500);
        },
      });
    },
  };

  return config;
}

export const INIT_CONFIG = getInitConfig();
